export default __webpack_public_path__ + "static/media/Modules.1195ccdf.png";